import { LoaderIcon } from 'lucide-react';

import { CommandEmpty } from '@/components/ui/command';

/**
 * Le retour visuel d'une liste d'options cherchée côté serveur : un indicateur circulaire pendant la
 * requête, « Aucun résultat » seulement une fois la réponse arrivée.
 *
 * Partagé par le CHAMP (`TotemSelect`, donc `UltraSelect`) et la PUCE de filtre
 * (`DataTableAsyncFilter`) : les deux surfaces divergeaient, la puce laissant la liste PRÉCÉDENTE
 * affichée pendant la frappe sans aucun signe de chargement.
 *
 * `data-test` : les tests E2E attendent la disparition de l'indicateur plutôt qu'un délai arbitraire.
 */
export function CommandOptionsFeedback({
    isLoading,
    emptyLabel = 'Aucun résultat',
}: {
    isLoading: boolean;
    emptyLabel?: string;
}) {
    if (isLoading) {
        return (
            <div className="flex items-center justify-center py-6" data-test="command-options-loading">
                <LoaderIcon className="size-4 animate-spin text-muted-foreground" />
            </div>
        );
    }

    return <CommandEmpty>{emptyLabel}</CommandEmpty>;
}
